<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    // 有参数 微信扫码回调
    this.$nextTick(function() {
      this.token = document.getElementsByName("__RequestVerificationToken")[0].value;
      if (!window.sessionStorage) {
        alert("您的浏览不不支持,请升级您的浏览器版本");
      } else {
        sessionStorage.setItem("hidRequestVerificationToken", this.token);
      }
    });
  }
};
</script>
<style lang="scss">
html,
body,
#app {
  min-height: 100%;
  min-height: 100vh;
}
body {
  margin: 0 !important;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "SimSun", "sans-serif";
    /* .app-warp{
      height: 100vh;
    } */
}
.impowerBox .qrcode {
  width: 260px;
}
.impowerBox .title {
  display: none;
}
</style>
